import React from "react";

const SettingsPreferencesCard = ({title, subtitle, more, contentInput}: {
    title: string;
    subtitle?: string;
    more?: string | React.ReactNode;
    contentInput: React.ReactNode
}): React.ReactElement => {

    return (
        <div className={"p-5 mx-4 my-2 radius-4 bg--surface-page settings__"}>
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
            {contentInput}
            <div>{more}</div>
        </div>
    )
};

export default SettingsPreferencesCard;